class Node {
  name: string;
  allowed: boolean;
  children: Record<string, Node>;

  constructor(name: string, allowed = false) {
    this.name = name;
    this.allowed = allowed;
    this.children = {};
  }

  addChild(node: Node): void {
    this.children[node.name] = node;
  }

  allow(aclTree: string[]): void {
    const tree = aclTree.slice();

    if (tree.length > 0) {
      const child = tree.shift();
      if (child && !this.children[child]) {
        this.addChild(new Node(child));
      }
      if (child) {
        this.children[child]?.allow(tree);
      }
    } else {
      this.allowed = true;
    }
  }

  isAllowed(aclTree: string[]): boolean {
    const tree = aclTree.slice();

    if (tree.length > 0) {
      const child = tree.shift();

      if (child === "*") {
        for (const name in this.children) {
          return this.children[name]?.isAllowed(tree) || false;
        }
        return false;
      } else {
        if (child && this.children[child]) {
          return this.children[child]?.isAllowed(tree) || false;
        } else if (Object.keys(this.children).length === 0) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return this.allowed;
    }
  }
}

export default Node;
